import { FaEnvelope } from "react-icons/fa"; // Similar to a bridge

export default function CareersInternships() {
  return (
    <section className="py-5 px-3 bg-white">
      {/* Internships Section */}
      <h2 className="text-center text-primary fw-bold display-6">Internships</h2>
      <p className="text-center text-secondary mt-2">
        We welcome enthusiastic individuals to join our internship program. Contact us and send your resume to explore opportunities!
      </p>
      <div className="mt-3 text-center">
        <p className="d-flex align-items-center justify-content-center text-secondary">
          <FaEnvelope className="me-2" /> blueberryinfratechpvtltd@gmail.com
        </p>
      </div>

      {/* Job Openings Section */}
      <h2 className="text-center text-primary fw-bold display-6 mt-5">Job Openings</h2>
      <div className="mt-4 mx-auto" style={{ maxWidth: "600px" }}>
        <div className="border rounded p-3 shadow-sm mb-3 bg-light">
          <h3 className="text-primary fw-semibold">Project Manager</h3>
          <p className="text-secondary mt-2">Looking for an experienced project manager to oversee infrastructure projects.</p>
        </div>
        <div className="border rounded p-3 shadow-sm bg-light">
          <h3 className="text-primary fw-semibold">Civil Engineer</h3>
          <p className="text-secondary mt-2">Seeking a skilled civil engineer to contribute to our upcoming projects.</p>
        </div>
      </div>
    </section>
  );
}
